
import request from '@/services/api';

// 获取招标列表
export function getTenderList(data) {
  return request({
    url: '/releaseTask/list',
    method: 'post',
    data: data
  })
}


// 招标详情
export function getTenderDetail(id) {
  return request({
    url: '/releaseTask/' + id,
    method: 'get',
   
  })
}   

// 招标删除
export function deleteTender(id) {
  return request({
    url: '/releaseTask/' + id + '/close',
    method: 'post',
  })
}

//创建招标
export function createTender(data) {
  return request({
    url: '/releaseTask/create',
    method: 'post',
    data: data
  })
}

// 查询投标列表
export function getTenderBidList(data) {
  return request({
    url: '/tenderBid/list',
    method: 'post',
    data: data
  })
}

// 提交投标
export function submitTenderBid(data) {
  return request({
    url: '/tenderBid/submit',
    method: 'post',
    data: data
  })
}

// 选择中标
export function awardTenderBid(id) {
  return request({
    url: `/tenderBid/${id}/award`,
    method: 'post'
  })
}